import React from 'react'
import 'component/Datepicker'
import './CustomFieldDateComponent.css'
import {CFComponentProps} from 'module/CustomField/type/CFComponentType'
import {stripHTML} from 'util/StringUtil'
import {DateComponent} from 'component/DateComponent'

export function CustomFieldDateComponent({rawValue, disabled, setCb, placeholderHTML}: CFComponentProps<number | null | undefined>) {
	return <div
		className={'CustomFieldDateComponent'}
		data-cursor-key-needs-modifier={true}
	>
		<DateComponent
			value={rawValue}
			onChange={setCb}
			disabled={disabled}
			placeholderText={stripHTML(placeholderHTML)}
			// placeholderHTML={placeholderHTML}
		/>
	</div>
}
